import { useEffect } from 'react'

import { getExpoPushToken, getIsMobileAppMode } from '@scouts/helpers'

import config from '@/config'
import { useMobilePushNotifications } from '@/store/push-notifications'

import { useResetSessionAndLogout } from './hooks/use-reset-session-and-logout'

export const Logout = () => {
    const { resetSessionAndLogout, isSuccess } = useResetSessionAndLogout()
    const { disablePushNotifications } = useMobilePushNotifications()

    const isMobileAppMode = getIsMobileAppMode()
    const expoPushToken = getExpoPushToken()

    const redirectUrl = isMobileAppMode ? config.baseUrl : config.siteLogoutUrl

    useEffect(() => {
        if (expoPushToken) {
            disablePushNotifications({ token: expoPushToken }).finally(() => {
                resetSessionAndLogout()
            })
            return
        }

        resetSessionAndLogout()
    }, [disablePushNotifications, expoPushToken, resetSessionAndLogout])

    useEffect(() => {
        if (!isSuccess) return

        window.location.replace(redirectUrl)
    }, [isSuccess, redirectUrl])

    return null
}
